import { css } from '@emotion/core';
export var polygonStyled = (starType, fillStar, fillBackground, strokeColor, strokeWidth) => /*#__PURE__*/css("fill:", starType === 4 ? fillStar : fillBackground, ";stroke:", strokeColor, ";stroke-width:", strokeWidth, "px;");
export var star = function star() {
  var size = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 20;
  return /*#__PURE__*/css("display:inline-flex;align-items:center;justify-content:center;height:", size, "px;width:", size, "px;");
};